export default {
    title: 'Sales Person Location',
    region: 'Area',
    status: 'Status',
    last_updated: 'Last updated',
    map_load_error: 'Could not load the map. Check REACT_APP_GOOGLE_MAP_KEY and network access.',
    status_on_route: 'On route',
    status_at_customer: 'At customer',
    status_idle: 'Idle',
    status_break: 'On break',
};